import features from 'src/replicant/ruleset/features';
import type { Component, Entity2D } from '../../odie';
import { CrateBlockView } from '../blocks/crate/CrateBlockView';

import { HatBlockProps } from '../defs/block';
import { HatBlockView } from '../views/blocks/HatBlockView';
import { user } from 'src/StateObserver';

// types
//-----------------------------------------------------------------------------
export type HatBlockComponentOptions = {
  props: HatBlockProps;
};

/*
    top hat block component
*/
export class HatBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockHat';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: HatBlockView | CrateBlockView;

  // impl
  //-------------------------------------------------------------------------
  public init(options: HatBlockComponentOptions): void {
    // If new first 2 obstacle visuals is enabled, use crate block view instead for neutral color hats
    if (
      features(user()).newFirst2ObstacleVisuals &&
      options.props.color === 'all'
    ) {
      this.view = new CrateBlockView(options.props);
      return;
    }

    // create hat block view
    this.view = new HatBlockView(options.props);
  }
}
